export const FileTypes = {
  SET_FILES: 'files',
  ADD_FILE: 'ADD_FILE'
};
